import { render, staticRenderFns } from "./SearchField.vue?vue&type=template&id=127c0fd8&scoped=true&"
import script from "./SearchField.vue?vue&type=script&lang=js&"
export * from "./SearchField.vue?vue&type=script&lang=js&"
import style0 from "./SearchField.vue?vue&type=style&index=0&id=127c0fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c0fd8",
  null
  
)

export default component.exports